export default "__VITE_ASSET__07313d3f__"